import Footer from "../../../../src/components/footer/footer.component.jsx";
import footerLogo from "../../../../src/images/footer-logo.svg";
import * as React from 'react';
export default {
  Footer,
  footerLogo,
  React
};